import React from 'react';
import { Container } from 'react-bootstrap';
import '../styling/About.css';

function About() {
  const aboutData = {
    bio: "Software engineer specializing in fintech and mobile development. I build production-ready applications with React Native, Django, and modern web technologies. With 5+ years of experience, I've delivered solutions for startups, enterprises, and open-source communities.",
    
    strengths: [
      {
        icon: "💪",
        title: "Hard Worker",
        description: "Committed to excellence and delivering quality work"
      },
      {
        icon: "⚡",
        title: "Fast Learner",
        description: "Quick to adapt to new technologies and frameworks"
      },
      {
        icon: "✨",
        title: "Satisfactory Output",
        description: "Consistent delivery of high-quality, production-ready code"
      },
      {
        icon: "⏱️",
        title: "Always On Schedule",
        description: "Reliable timeline management and deadline adherence"
      },
      {
        icon: "🎯",
        title: "Allergic to Failure",
        description: "Driven to exceed expectations and overcome challenges"
      }
    ],

    hobbies: [
      {
        icon: "🏋️",
        title: "Workout",
        description: "Staying fit and maintaining a healthy lifestyle"
      },
      {
        icon: "🎬",
        title: "Watch Movies",
        description: "Enjoying cinema and storytelling"
      },
      {
        icon: "📚",
        title: "Read Comics",
        description: "Following graphic novels and comic book stories"
      },
      {
        icon: "🎮",
        title: "Gaming",
        description: "Casual gaming and exploring new game experiences"
      }
    ],

    socials: [
      {
        platform: "Facebook",
        icon: "facebook",
        url: "https://facebook.com/robinokwanma",
        color: "#1877F2"
      },
      {
        platform: "Twitter",
        icon: "twitter",
        url: "https://x.com/robinokwanma",
        color: "#000000"
      },
      {
        platform: "LinkedIn",
        icon: "linkedin",
        url: "https://linkedin.com/in/robinokwanma",
        color: "#0A66C2"
      },
      {
        platform: "WhatsApp",
        icon: "whatsapp",
        url: "https://wa.me/2348148190856",
        color: "#25D366"
      },
      {
        platform: "GitHub",
        icon: "github",
        url: "https://github.com/robinokwanma",
        color: "#181717"
      }
    ]
  };

  return (
    <section className="about-section">
      <Container className="about-container">
        {/* Header */}
        <div className="about-header">
          <span className="section-accent">About Me</span>
          <h2 className="section-title">
            A Little <span className="title-highlight">About Me</span>
          </h2>
          <p className="section-subtitle">
            Full-stack engineer, builder, and tech enthusiast
          </p>
          <div className="title-underline"></div>
        </div>

        {/* Main Content */}
        <div className="about-content">
          {/* Left Column - Profile */}
          <div className="about-left">
            <div className="profile-image-wrapper">
              <img 
                src="/images/robingym.jpg" 
                alt="Robin Okwanma" 
                className="profile-image"
              />
            </div>

            {/* Bio */}
            <div className="about-bio">
              <h3 className="bio-title">Who I Am</h3>
              <p className="bio-text">
                {aboutData.bio}
              </p>
            </div>

            {/* Social Links */}
            <div className="social-links">
              <h4 className="social-title">Connect With Me</h4>
              <div className="social-icons">
                {aboutData.socials.map((social, idx) => (
                  <a
                    key={idx}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                    title={social.platform}
                    aria-label={`Connect on ${social.platform}`}
                  >
                    <i className={`bi bi-${social.icon}`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Right Column - Strengths & Hobbies */}
          <div className="about-right">
            {/* Strengths Section */}
            <div className="about-section-card">
              <div className="card-header">
                <h3 className="card-title">💪 Strengths</h3>
                <p className="card-subtitle">Why Work With Me?</p>
              </div>

              <div className="traits-grid">
                {aboutData.strengths.map((strength, idx) => (
                  <div key={idx} className="trait-item">
                    <div className="trait-icon">{strength.icon}</div>
                    <div className="trait-content">
                      <h4 className="trait-title">{strength.title}</h4>
                      <p className="trait-description">{strength.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Hobbies Section */}
            <div className="about-section-card">
              <div className="card-header">
                <h3 className="card-title">🎯 Hobbies</h3>
                <p className="card-subtitle">What I Do When Away From Code</p>
              </div>

              <div className="traits-grid">
                {aboutData.hobbies.map((hobby, idx) => (
                  <div key={idx} className="trait-item">
                    <div className="trait-icon">{hobby.icon}</div>
                    <div className="trait-content">
                      <h4 className="trait-title">{hobby.title}</h4>
                      <p className="trait-description">{hobby.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="about-stats">
          <div className="stat-card">
            <div className="stat-icon">🎓</div>
            <div className="stat-number">B.Tech</div>
            <div className="stat-label">Information Technology</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-card">
            <div className="stat-icon">🌍</div>
            <div className="stat-number">Port Harcourt</div>
            <div className="stat-label">Nigeria</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-card">
            <div className="stat-icon">⭐</div>
            <div className="stat-number">5+</div>
            <div className="stat-label">Years Experience</div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default About;